import { render } from "./roadmap.vue?vue&type=template&id=4f0b02f1"
import script from "./roadmap.vue?vue&type=script&lang=js"
export * from "./roadmap.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3474900079/src/relsify_nft_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__